export class Cost {
    motes: number = 0;
    willpower: number = 0;
    anima: number = 0;
    initiative: number = 0;
}
